// client/src/pages/BlogPage.js

import React, { useState, useEffect } from 'react';
import sanityClient from '../sanity';
import BlockContent from '@sanity/block-content-to-react';
import '../styles/BlogPage.css';
import '../styles/PageHero.css';

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [expandedBlogIds, setExpandedBlogIds] = useState([]); // State to handle expanded blogs

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "blog"]{
        _id, title, author, content, publishedAt, mainImage{
          asset->{
            _id, url
          }
        }
      }`
      )
      .then((data) => setBlogs(data))
      .catch(console.error);
  }, []);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  // Function to limit the blog content preview
  const getPreviewText = (content, isExpanded) => {
    const plainTextContent = content
      .map((block) => block.children.map((child) => child.text).join(''))
      .join(' ');
    return isExpanded ? null : plainTextContent.slice(0, 200) + '...';
  };

  // Toggle expanded blog posts
  const toggleReadMore = (blogId) => {
    setExpandedBlogIds((prevState) =>
      prevState.includes(blogId)
        ? prevState.filter((id) => id !== blogId)
        : [...prevState, blogId]
    );
  };

  return (
    
    <div className="blog-page">
        <div
        className="about-hero page-photo-hero"  
        style={{ backgroundImage: 'url(b2.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <div className="contact-header">

              <h1 className="page-header-title page-hero-title page-hero-lower-title">
                  Blog <span className="highlight">Posts</span>
              </h1>

          </div>
        </div>
      {blogs.length > 0 ? (
        blogs.map((blog) => {
          const isExpanded = expandedBlogIds.includes(blog._id); // Check if the blog is expanded
          return (
            <div key={blog._id} className={`blog-post${isExpanded ? ' expanded' : ''}`}>
              <div className={`blog-content-container${isExpanded ? ' expanded' : ''}`}>
                <div className="blog-image-container">
                  {blog.mainImage && (
                    <img
                      src={blog.mainImage.asset.url}
                      alt={blog.title}
                      className="blog-image"
                    />
                  )}
                </div>
                <div className="blog-text-container">
                  <h2>{blog.title}</h2>
                  <p className="author">By {blog.author}</p>
                  {getPreviewText(blog.content, isExpanded) && (
                    <p>{getPreviewText(blog.content, isExpanded)}</p>
                  )}
                  {isExpanded && (
                    <>
                      <BlockContent blocks={blog.content} className="blog-content" />
                      <button
                        className="read-more-btn"
                        onClick={() => toggleReadMore(blog._id)}
                      >
                        Show Less
                      </button>
                    </>
                  )}
                  {!isExpanded && (
                    <button
                      className="read-more-btn"
                      onClick={() => toggleReadMore(blog._id)}
                    >
                      Read More
                    </button>
                  )}
                  <small className="published-date">
                    Published at: {blog.publishedAt ? formatDate(blog.publishedAt) : 'Unknown Date'}
                  </small>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <p>No blogs available</p>
      )}
    </div>
  );
};

export default BlogPage;
